import { Component, Input } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ProducerUser } from "@models/user";
import { ImgFallbackDirective } from "@shared/directives/img-fallback/img-fallback.directive";
import { SkeletonModule } from "primeng/skeleton";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-producer-card",
  imports: [SkeletonModule, ImgFallbackDirective, RouterModule],
  templateUrl: "./producer-card.component.html",
  styleUrl: "./producer-card.component.scss",
})
export class ProducerCardComponent {
  @Input() producer: ProducerUser | null = null;

  readonly fallbackImage = "assets/images/default-profile.png";

  get thumbnailUrl(): string {
    const thumbnail = this.producer?.thumbnail;
    if (!thumbnail) return this.fallbackImage;
    if (/^https?:\/\//i.test(thumbnail)) return thumbnail;
    return `${environment.BLOB_URL}/${thumbnail}`;
  }

  get displayName(): string {
    const producer = this.producer;
    if (!producer) return "";
    if (producer.company) return producer.company_name ?? "";
    return [producer.name, producer.last_name].filter(Boolean).join(" ");
  }
}
